import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import { ScaleLoader } from 'react-spinners';

export default function DatosPersonales({ portadaDocente, loading }) {

    const { darkMode } = useDarkMode();

    const dynamicStyles = darkMode ? darkModeStyles : lightModeStyles;

    return (
        <div className="mb-2">
            {loading ?
                <div style={{ 
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px'
                }}>
                    <ScaleLoader color='#972034' />
                </div>
                :
                <>
                    <h2 className="pb-2" style={{ ...dynamicStyles.title, fontSize: '1.45rem' }}>Datos Personales</h2>
                    {portadaDocente && (
                        <>
                            <ul style={styles.list}>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Nombre:</span> {portadaDocente.nombre}
                                </li>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Apellido:</span> {portadaDocente.apellido}
                                </li>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Legajo:</span> {portadaDocente.legajo}
                                </li>                                
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Tipo Documento:</span> {portadaDocente.tipo_documento}
                                </li>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Número Documento:</span> {portadaDocente.documento}
                                </li>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Correo Electrónico Institucional:</span> {portadaDocente.mail}
                                </li>
                            </ul>
                        </>
                    )
                    }
                </>
            }
        </div>
    )
}

const lightModeStyles = {
    title: {
        color: '#A23C41',
        borderBottom: '4px solid #646354'
    }
};

const darkModeStyles = {
    title: {
        borderBottom: '4px solid #495057'
    }
};

const styles = {
    list: {
        paddingLeft: "20px",
        listStyleType: "disc",
    },
    listItem: {
        marginBottom: "5px",
    },
    boldText: {
        fontWeight: "bold",
        fontSize: 18
    }
};